/** Create a {@link SimpleDomRect} from the bare minimum info. */
function makeSimpleDomRect(x, y, width, height) {
    return { x, y, top: y, left: x, right: x + width, bottom: y + height, width, height };
}
function doRectsOverlap(rect1, rect2) {
    return !(rect1.right <= rect2.left || // rect1 is completely to the left of rect2
        rect1.left >= rect2.right || // rect1 is completely to the right of rect2
        rect1.bottom <= rect2.top || // rect1 is completely above rect2
        rect1.top >= rect2.bottom // rect1 is completely below rect2
    );
}
/**
 * Walks up the dom to find the closest element that matches the predicate. Can return
 * the passed in `el` if it matches. If your predicate can be expressed as a query selector and you
 * don't need to stop at a specific element, consider using `el.closest(selector)` instead.
 */
function findClosest(start, predicate, stopAt) {
    let el = start;
    while (el) {
        if (predicate(el))
            return el;
        if (el === stopAt)
            break;
        el = el.parentElement;
    }
    return null;
}
/**
 * Return -1 if `el` is before `other`, 1 if `el` is after `other`, or 0 if they are
 * the same or order can't be determined.
 *
 * This is a wrapper over `el.compareDocumentPosition` that simplifies the
 * common case of comparing two elements we know are in the same document.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
 */
function compareDocumentPosition(el, other) {
    const result = el.compareDocumentPosition(other);
    return result & 2 ? 1 : result & 4 ? -1 : 0;
}
/**
 * Simple wrapper around `document.elementFromPoint` that automatically
 * uses the event's clientX and clientY values.
 */
function elementUnderMouse(e) {
    return document.elementFromPoint(e.clientX, e.clientY);
}
/** Check if an element is disabled */
function isDisabled(node) {
    if (node.nodeType !== 1)
        return false;
    const d = node.getAttribute('disabled') ?? node.getAttribute('aria-disabled');
    return d === '' || d === 'true';
}
/**
 * Check if a node is an Element node. Relies on `nodeType` rather than instanceof, so
 * resilient to cross-realm issues.
 */
function isElement(node) {
    if (!node || typeof node !== 'object')
        return false;
    return 'nodeType' in node && node.nodeType === 1; /* Node.ELEMENT_NODE */
}
/** Get the document containing an element, falling back to the current document. */
function getOwnerDocument(element) {
    return element?.ownerDocument ?? document;
}
/** Get the window containing an element, falling back to the current window. */
function getOwnerWindow(element) {
    return getOwnerDocument(element).defaultView ?? window;
}
/** "Cast" a node to an element, returning null if it is not an element. */
function asElement(node) {
    return isElement(node) ? node : null;
}
function setBooleanAttribute(el, attr, value) {
    if (value) {
        el.setAttribute(attr, '');
    }
    else {
        el.removeAttribute(attr);
    }
}

export { asElement, compareDocumentPosition, doRectsOverlap, elementUnderMouse, findClosest, getOwnerDocument, getOwnerWindow, isDisabled, isElement, makeSimpleDomRect, setBooleanAttribute };
//# sourceMappingURL=dom.js.map
